import React, { useState } from 'react';
import { useData } from '../DataContext';
import { useLang } from '../LanguageContext';
import { useNavigate, Navigate } from 'react-router-dom'; 

const Login = () => {
  const navigate = useNavigate();
  // ★ login 함수를 가져옵니다.
  const { currentUser, login } = useData(); 
  const { t, setLang, lang } = useLang();
  
  const [id, setId] = useState('');
  const [pw, setPw] = useState('');

  // 이미 로그인 된 상태라면 대시보드로 이동
  if (currentUser) return <Navigate to="/" />;

  const handleLogin = () => {
    if (!id || !pw) {
      alert("ID와 비밀번호를 입력해주세요.");
      return;
    }

    // ★ DataContext의 login 함수 호출 (진짜 검증)
    const success = login(id, pw);

    if (success) {
      navigate('/'); // 로그인 성공 시 이동
    } else {
      alert("로그인 정보가 올바르지 않습니다.\n(ID/PW를 확인해주세요)");
    }
  };

  return (
    <div style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#0f172a', color: 'white', flexDirection: 'column' }}>
      
      {/* 언어 선택 버튼 */}
      <div style={{ marginBottom:'20px', display:'flex', gap:'10px' }}>
          {['KR','EN','CN','JP'].map(l => (
              <button key={l} onClick={()=>setLang(l)} style={{ padding:'8px 16px', background: lang===l?'#2563eb':'#334155', color:'white', border:'none', borderRadius:'4px', cursor:'pointer', fontWeight:'bold' }}>{l}</button>
          ))}
      </div>

      <div style={{ width: '350px', padding: '40px', backgroundColor: '#1e293b', borderRadius: '10px', textAlign: 'center', boxShadow:'0 10px 25px rgba(0,0,0,0.5)' }}>
        <h2 style={{ marginBottom: '30px' }}>{t ? t('loginTitle') : 'LOGIN'}</h2>
        
        {/* 아이디 입력 */}
        <input 
          placeholder={t ? t('idPlace') : 'ID'} 
          value={id} 
          onChange={e=>setId(e.target.value)} 
          style={{ width:'100%', padding:'12px', marginBottom:'15px', borderRadius:'5px', border:'none', color: 'black' }} 
        />
        
        {/* 비밀번호 입력 */}
        <input 
          type="password" 
          placeholder={t ? t('pwPlace') : 'Password'} 
          value={pw} 
          onChange={e=>setPw(e.target.value)} 
          onKeyPress={e=>e.key==='Enter'&&handleLogin()} 
          style={{ width:'100%', padding:'12px', marginBottom:'25px', borderRadius:'5px', border:'none', color: 'black' }} 
        />
        
        {/* 로그인 버튼 */}
        <button onClick={handleLogin} style={{width:'100%', padding:'12px', background:'#2563eb', color:'white', fontWeight:'bold', border:'none', borderRadius:'5px', cursor:'pointer'}}>
          {t ? t('loginBtn') : 'Sign In'}
        </button>
      </div>
    </div>
  );
};

export default Login;